<template>
    <div>
        <div class="form-row">
            <div class="form-label">
                <label class="required">编码</label>
            </div>
            <div class="form-value width-2x">
                <span>{{custTaxPayType.code}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label class="required">名称</label>
            </div>
            <div class="form-value width-2x">
                <span> {{custTaxPayType.name}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label class="required">纳税类型</label>
            </div>
            <div class="form-value width-2x">
                <span>{{custTaxPayType.stdName}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import merchtComnApi from '../../api/merchtComn'

    export default{
        name: 'swb-cust-tax-pay-type-show',
        desc: '自定义纳税类型查看',
        props: ["id"],
        data: function () {
            return {
                custTaxPayType: {},
            }
        },
        created: function () {
            //
            this.getCustTaxPayType();
        },
        methods: {
            //
            getCustTaxPayType: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                //
                let msgBoxDlg = MsgBox.loading();
                merchtComnApi.getCustTaxPayTypeById(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let custTaxPayType = result.data;
                        self.custTaxPayType = Utils.merge({}, custTaxPayType);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/comn/CustTaxPayTypeShow.vue